import ShortNav from "../../shared/components/header/navigation.short.r";
import SideNav from "../../shared/components/header/navigation.extern.r";
import Notifications from "@phoenixreisen/reacts/src/notification";
import Footer from "../../shared/components/footer/footer.intern.r";
import Header from "../../shared/components/header/header.r";
import { PATH } from "../shared/models/model";
import React from "react";
export const Layout = ({ noWrapper, children }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { noImg: false, noNav: false, logoUrl: PATH, SideNav: SideNav, ShortNav: ShortNav, headline: "Schiffsbesichtigung", version: "Phoenix Reisen - Schiffsbesichtigung" }),
        React.createElement("div", { className: !noWrapper && "wrapper wrapper--large pt0" }, children),
        React.createElement(Footer, null),
        React.createElement(Notifications, null)));
};
export default Layout;
